import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingIndicatorService } from 'src/app/core/services/loading-indicator.service';

@Component({
  selector: 'th-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private loadingIndicatorService: LoadingIndicatorService
  ) {}

  public async ngOnInit() {
    this.loadingIndicatorService.show();
    await this.authService.logout();
    this.loadingIndicatorService.hide();
    this.authService.stopIdleTimer();
    this.router.navigate(['/login']);
  }
}
